export const ADD_MESSAGE = 'ADD_MESSAGE'
export const SET_MESSAGES_TAB_OPEN = 'SET_MESSAGES_TAB_OPEN'
